<template>
  <step-status-tracker
    v-if="enableStepStatusTracker"
    class="eu-fade-in"
    id="timeline-activation-step-status-tracker"
  />
  <step-finished
    v-else-if="enableStepFinish"
    class="eu-fade-in"
    @closeFullActivation="closeFullActivation"
    id="timeline-activation-step-finish"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  TIMELINE_STEPS_ENUM as STEPS_TIMELINE,
  enableGetChargesPaid,
  isStepTimelineActivationActive,
  isStepTimelineActivationFinished
} from './timeline-activation-steps.enum'

export default {
  name: 'TimelineActivation',
  props: {
    showGreeting: {
      type: Boolean
    }
  },
  components: {
    StepStatusTracker: () => import('./DashStepStatusTracker/index.vue'),
    StepFinished: () => import('./DashStepFinished/index.vue')
  },
  computed: {
    ...mapGetters(['merchant', 'account', 'timelineActivation', 'charges']),
    enableStepStatusTracker () {
      return isStepTimelineActivationActive(this.timelineActivation.step)
    },
    enableStepFinish () {
      return isStepTimelineActivationFinished(this.timelineActivation.step)
    }
  },
  created () {
    this.disableGreeting()
    this.GET_TIMELINE_ACTIVATION()
    this.fetchChargesPaid()
  },
  methods: {
    ...mapActions([
      'GET_CHARGES_PAID',
      'UPDATE_TIMELINE_STEP_ACTIVATION',
      'DISABLED_TIMELINE_ACTIVATION',
      'GET_TIMELINE_ACTIVATION'
    ]),
    hasEmptyCharges (items) {
      return items?.length === 0
    },
    hasOneCharge (items) {
      return items?.length === 1
    },
    disableGreeting () {
      if (this.showGreeting) {
        this.$emit('closeGreeting')
      }
    },
    closeFullActivation () {
      this.DISABLED_TIMELINE_ACTIVATION()
    },
    setStepTimelineActivationByCharges (items = []) {
      if (this.hasEmptyCharges(items)) {
        this.UPDATE_TIMELINE_STEP_ACTIVATION(STEPS_TIMELINE.ACTIVE)
      } else if (this.hasOneCharge(items)) {
        this.UPDATE_TIMELINE_STEP_ACTIVATION(STEPS_TIMELINE.FINISHED)
      } else {
        this.DISABLED_TIMELINE_ACTIVATION()
      }
    },
    fetchChargesPaid () {
      if (enableGetChargesPaid(this.timelineActivation?.step)) {
        this.GET_CHARGES_PAID().then(({ items }) =>
          this.setStepTimelineActivationByCharges(items)
        )
      }
    }
  },
  watch: {
    charges: {
      handler () {
        this.fetchChargesPaid()
      }
    }
  }
}
</script>
